// extracted by mini-css-extract-plugin
export var container = "header-pwa-module--container--5ad34";
export var icon = "header-pwa-module--icon--2a742";
export var label = "header-pwa-module--label--165e0";
export var link = "header-pwa-module--link--68be1";
export var returnLink = "header-pwa-module--returnLink--bf217";
export var spacer = "header-pwa-module--spacer--cc011";